import { useState, useEffect } from 'react';
import Breadcrumb from '../../../Common/Breadcrumb';
import { APIClient } from "../../../helpers/api_helper";
import { Card, Col, Row, Form, Breadcrumb as AntBreadcrumb } from 'antd';
import BasePieChartWithTable from '../../../Common/BasePieChartWithTable';
import AmountFieldSelect from '../../../Common/AmountFieldSelect';
import { useSelector, useDispatch } from "react-redux";
import utils from '../../../Common/utils';
import { setInitialFilterConf, updateFilterData } from '../../../slices/filters/thunk'
import { Link } from 'react-router-dom';
import ShowIntentsBtn from '../../../Common/ShowIntentsBtn';


const api = new APIClient();


const InsightsExpenses = () => {
  document.title = "Odhodki" + process.env.REACT_APP_PAGE_TITLE;
  const dispatch = useDispatch();

  const filterdata = useSelector((state) => state.Filterdata.data)
  console.log('EXPENSES FILTER DATA', filterdata)
  const [expensesByCompanyData, setExpensesByCompanyData] = useState([]);
  const [expensesByTagData, setExpensesByTagData] = useState([]);
  const [expensesByProjectData, setExpensesByProjectData] = useState([]);
  const [loadingByTag, setLoadingByTag] = useState(false);
  const [loadingByCompany, setLoadingByCompany] = useState(false);
  const [loadingByProject, setLoadingByProject] = useState(false);
  // Breadcrumb of the tag the "Po oznaki" chart is drilled into (empty = top level).
  const [tagPath, setTagPath] = useState([]);

  const loadByTag = () => {
    const tagParent = tagPath.length ? tagPath[tagPath.length - 1].id : undefined;
    setLoadingByTag(true);
    api.get('/api/insights/expenses_by_tag/', { ...utils.toFilterParams(filterdata), tag_parent: tagParent })
      .then(resp => setExpensesByTagData(resp))
      .finally(() => setLoadingByTag(false));
  }

  const loadInsightsData = () => {
    setLoadingByCompany(true);
    api.get('/api/insights/expenses_by_company/', utils.toFilterParams(filterdata))
      .then(resp => setExpensesByCompanyData(resp))
      .finally(() => setLoadingByCompany(false));
    setLoadingByProject(true);
    api.get('/api/insights/expenses_by_project/', utils.toFilterParams(filterdata))
      .then(resp => setExpensesByProjectData(resp))
      .finally(() => setLoadingByProject(false));
  }

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: { amount_field: 'amount_no_tax' },
      hidden: ['intent_type', 'intent_checkboxes_group'],
      disabled: ['search'],
      masterSearch: true,
    }))
  }, []);

  // Drilling resets when the global filters change.
  useEffect(() => {
    setTagPath([]);
    loadInsightsData()
  }, [filterdata]);

  useEffect(() => {
    loadByTag()
  }, [filterdata, tagPath]);

  const crumbLink = (label, onClick) => (
    <span style={{ cursor: 'pointer' }} onClick={onClick}>{label}</span>
  );
  const tagBreadcrumb = (
    <AntBreadcrumb
      style={{ marginBottom: 8 }}
      items={[
        { title: crumbLink('Vse oznake', () => setTagPath([])) },
        ...tagPath.map((t, i) => ({
          title: i === tagPath.length - 1
            ? t.title
            : crumbLink(t.title, () => setTagPath(tagPath.slice(0, i + 1)))
        })),
      ]}
    />
  );


  return (
    <>
      <Breadcrumb parentTitle="Vpogledi" pageTitle="Odhodki" />
      <>
        <Col xs={24} className="gutter-row">

            <Row>
              <Col span={4}>
                <Form.Item label="Znesek">
                  <AmountFieldSelect
                    value={filterdata.amount_field || 'amount_no_tax'}
                    onChange={val => dispatch(updateFilterData({ amount_field: val }))}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>

              <Col xs={24} md={12} xl={8}>
                <Card title="Po oznaki" extra={<Link to={{pathname: "/intents", hash: utils.getUpdatedURL()}}><ShowIntentsBtn size='large' /></Link>}>
                  <BasePieChartWithTable
                    data={expensesByTagData}
                    loading={loadingByTag}
                    aggColTitle={'Oznaka'}
                    filterName={'tags_filters'}
                    moneyType={'EXPENSE'}
                    headerExtra={tagPath.length > 0 ? tagBreadcrumb : null}
                    onDrillDown={row => setTagPath([...tagPath, { id: row.id, title: row.title }])}
                  />
                </Card>
              </Col>

              <Col xs={24} md={12} xl={8}>
                <Card title="Po podjetju" extra={<Link to={{pathname: "/intents", hash: utils.getUpdatedURL()}}><ShowIntentsBtn size='large' /></Link>}>
                  <BasePieChartWithTable
                    data={expensesByCompanyData}
                    loading={loadingByCompany}
                    aggColTitle={'Podjetje'}
                    filterName={'companies'}
                    moneyType={'EXPENSE'}
                  />
                </Card>
              </Col>

              <Col xs={24} md={12} xl={8}>
                <Card title="Po projektu" extra={<Link to={{pathname: "/intents", hash: utils.getUpdatedURL()}}><ShowIntentsBtn size='large' /></Link>}>
                  <BasePieChartWithTable
                    data={expensesByProjectData}
                    loading={loadingByProject}
                    aggColTitle={'Projekt'}
                    filterName={'projects'}
                    moneyType={'EXPENSE'}
                  />
                </Card>
              </Col>
            </Row>

        </Col>
      </>
    </>
  )
}

export default InsightsExpenses;
